import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type { ScheduleFormData } from '@/modules/schedule/types/schedule-form-data.type'
import { MESSAGES } from '@/modules/shared/constants/messages'
import { useToast } from '@/modules/shared/hooks/use-toast'
import type { MutationRequest } from '@/modules/shared/types/mutation-request.type'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'
import { saveScheduleService } from '../services/save-schedule.service'


export const useSaveScheduleMutation = ({
  callback,
  resolveRequest,
}: MutationRequest) => {
  const { toast } = useToast()
  const { mutateAsync: saveScheduleFn } = useMutation({
    mutationFn: (data: ScheduleFormData) => saveScheduleService(data),
    onSuccess: (data) => {
      resolveRequest({
        callback,
        status: data.status,
        showToastInfo: true,
        message: data.message,
        showToastSuccess: true,
      })
    },
    onError: (error: AxiosError<ResponseAPI>) => {
      if (
        error.response?.data?.status > 400 &&
        error.response?.data?.status < 500 &&
        error.response?.data?.message
      ) {
        toast.info({
          title: error.response.data.message,
        })
      } else {
        toast.error({
          title: MESSAGES.ERROR_TITLE,
          description: MESSAGES.ERROR_DESCRIPTION,
          action: {
            label: MESSAGES.RELOAD,
            onClick: () => {
              window.location.reload()
            },
          },
        })
      }
    },
  })

  return {
    saveScheduleFn,
  }
}
